import { graphql } from '@/generated/gql';

export const DEMAND_RECOMMENDATION_APPLY_MUTATION = graphql(/* GraphQL */ `
  mutation DemandRecommendationApply($demandId: UUID!, $data: [TsrctRecommendationsInput!]!) {
    tesseract {
      demand(id: $demandId) {
        demandRequest {
          recommendations {
            apply(demandId: $demandId, data: $data) {
              id
              decisionStatus
              variant
              demandRequestItemId
              recommendedItem
            }
          }
        }
      }
    }
  }
`);
